import React from "react";
import meditation from "../images/meditation.png";
import lotus from "../images/lotus.png";
import mind from "../images/mind.png";
import exercise from "../images/exercise.png";
// import support from "../images/support.png";
// import coach from "../images/coach.png";
// import mindset from "../images/mindset.png";
// import innovation from "../images/innovation.png";

const Mission = () => {
  return (
    <>
      <section className="animate">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="mb-1">MY MISSION</h2>
              <p className="mb-1">
                To help individuals unlock their true potential and move beyond
                inner limitations—so they can build lives that feel aligned,
                confident and fulfilling.
              </p>
              <p>Through coaching, you will:</p>
              <div className="row mt-4">
                <div className="col-lg-3 col-md-6 mb-5">
                  <div className="mission_card">
                    <div className="mission_card_icon">
                      <img src={meditation} alt="" />
                    </div>
                    <p>Gain clarity and direction</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 mb-5">
                  <div className="mission_card">
                    <div className="mission_card_icon">
                      <img src={lotus} alt="" />
                    </div>
                    <p>Build confidence and emotional resilience</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 mb-5">
                  <div className="mission_card">
                    <div className="mission_card_icon">
                      <img src={mind} alt="" />
                    </div>
                    <p>Overcome fear and limiting beliefs</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 mb-5">
                  <div className="mission_card">
                    <div className="mission_card_icon">
                      <img src={exercise} alt="" />
                    </div>
                    <p>Create balance and lasting change</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12 why_Anchor">
              <h2>WHY WORK WITH ME</h2>
              <div className="row mt-4">
                <div className="col-lg-3 col-md-6 mb-5">
                  <div className="mission_card">
                    {/* <div className="mission_card_icon">
                      <img src={support} alt="" />
                    </div> */}
                    <p>13+ years of cross-industry experience</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 mb-5">
                  <div className="mission_card">
                    {/* <div className="mission_card_icon">
                      <img src={coach} alt="" />
                    </div> */}
                    <p>Strong academic and professional foundation</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 mb-5">
                  <div className="mission_card">
                    {/* <div className="mission_card_icon">
                      <img src={mindset} alt="" />
                    </div> */}
                    <p>Certified in counselling, coaching and psychotherapy</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 mb-5">
                  <div className="mission_card">
                    {/* <div className="mission_card_icon">
                      <img src={innovation} alt="" />
                    </div> */}
                    <p>
                      Deep commitment to helping individuals grow and thrive
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Mission;
